import { lazy } from 'react';

const Resubmit = lazy(() => import('./AdminResubmitPage'));

const AdminResubmitConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: 'admin/resubmit-requests',
      element: <Resubmit />,
    },
  ],
};

export default AdminResubmitConfig;
